import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import styles from "./Table.module.css";
import Search from "../../shared-components/Search/Search";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Modal from "../Modal/Modal";
import useApiFetcher from "../../hooks/useApiFetcher";
import { AiOutlineLock } from "react-icons/ai";

const Table = ({
  columns,
  Dealers,
  handleEdit,
  handleDelete,
  query,
  setquery,
}) => {
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const totalPages = Math.ceil(Dealers?.length / itemsPerPage);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState('');

  const { apiFetcher } = useApiFetcher();

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    setPasswordsMatch(e.target.value === confirmPassword);
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setPasswordsMatch(e.target.value === newPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordsMatch) return;

    try {
      const response = await apiFetcher('/auth/reset-password-by-admin', "POST", { password: newPassword, email: selectedDealer?.email });
      closeModal()

    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  useEffect(() => {
    const updatedFilteredUsers = query
      ? Dealers.filter((dealer) =>
        dealer.dealershipId?.dealershipName
          ?.toLowerCase()
          .includes(query.toLowerCase())
      )
      : [];
    setFilteredUsers(updatedFilteredUsers);
  }, [query, Dealers]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Dealers?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedDealer(null)
    setConfirmPassword(null)
    setNewPassword(null)

  };
  const renderTableRows = (dealers) =>
    dealers.map((dealer, index) => {
      const sequentialId = (currentPage - 1) * itemsPerPage + (index + 1); // Calculate global index
      return (
        <tr key={sequentialId}>
          <td>{sequentialId}</td> {/* Use sequential ID */}
          <td className={styles.profileImgContainer}>
            {dealer?.dealershipId?.dealershipName || "N/A"}
          </td>
          <td>{dealer.email}</td>
          <td>
            {dealer.assignedModules.length > 0 ? (
              dealer.assignedModules.map((module, i) => (
                <span key={i}>
                  {module?.module?.name} ({module.permissions.join(", ")})
                  {i < dealer.assignedModules.length - 1 ? ", " : ""}
                </span>
              ))
            ) : (
              <span>No Modules</span>
            )}
          </td>
          <td>
            {dealer.assignedProducts.length > 0 ? (
              dealer.assignedProducts.map((product, i) => (
                <span key={i}>
                  {product?.product?.name} ({product.permissions.join(", ")})
                  {i < dealer.assignedProducts.length - 1 ? ", " : ""}
                </span>
              ))
            ) : (
              <span>No Products</span>
            )}
          </td>
          <td>
            <div className={styles.buttonContainer}>

              <button
                onClick={() => handleEdit(dealer)}
                className={`${styles.button} ${styles.edit}`}
              >
                <FaEdit />
              </button>
              <button
                onClick={() => handleDelete(dealer._id)}
                className={`${styles.button} ${styles.delete}`}
              >
                <MdDelete />
              </button>
            </div>
          </td>
          <td>
            <div className={styles.buttonContainer}>
              <button
                onClick={() => { setModalIsOpen(true); setSelectedDealer(dealer) }}
                className={`${styles.button} ${styles.reset}`}
              >
                Reset Password
              </button>

            </div>
          </td>
        </tr>
      );
    });

  const displayItems =
    query && filteredUsers.length > 0
      ? filteredUsers
      : query
        ? [] // If query exists but no match
        : currentItems;

  return (
    <div className={styles.Container}>
      <Search
        query={query}
        setquery={setquery}
        placeholder="Search for Dealer Name"
      />
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {columns.map(({ name }, index) => (
                <th className={styles.tableth} key={index}>{name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayItems.length === 0 ? (
              <tr>
                <td colSpan={columns.length}>
                  {query ? "No results found" : "No data available"}
                </td>
              </tr>
            ) : (
              renderTableRows(displayItems)
            )}
          </tbody>
        </table>
      </div>
      {!query && (
        <div className={styles.pagination}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={styles.paginationButton}
          >
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={`${styles.paginationButton} ${currentPage === index + 1 ? styles.active : ""
                }`}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={styles.paginationButton}
          >
            Next
          </button>
        </div>
      )}

      <Modal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        className={styles.model}
        title={"Reset Password"}
      >
        <div className={styles.modalBody}>
          <form onSubmit={handleSubmit}>
            <label htmlFor="avatar">Name</label>
            <div className={styles.inputGroup}>

              <input
                value={selectedDealer?.dealershipId?.dealershipName}
                className={styles.input}
                disabled={true}
                readOnly={true}
              />
            </div>
            <label htmlFor="avatar">Email</label>
            <div className={styles.inputGroup}>

              <input
                value={selectedDealer?.email}
                className={styles.input}
                disabled={true}
                readOnly={true}
              />
            </div>
            <div className={styles.inputGroup}>
              <AiOutlineLock className={styles.icon} />
              <input
                type="password"
                placeholder="Enter New Password"
                value={newPassword}
                onChange={handleNewPasswordChange}
                className={styles.input}
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <AiOutlineLock className={styles.icon} />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                className={styles.input}
                required
              />
            </div>

            <button type="submit" className={styles.button1} disabled={!passwordsMatch}>
              Continue
            </button>

            {!passwordsMatch && confirmPassword && (
              <p className={styles.errorText} style={{ color: "red", marginTop: '4px', fontSize: '12px' }}>Passwords do not match</p>
            )}
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default Table;